/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * are product suggestions enabled
 * @agent-skills: tenant-context
 */
export const useAreProductSuggestionsEnabled = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.areProductSuggestionsEnabled) || false;
};
